import { useRef, useEffect, ReactNode, CSSProperties } from "react";
import "./style.scss";
import classNames from "classnames";

interface InfiniteScrollProps {
    onIntersect: () => void;
    hasMore: boolean;
    children: ReactNode;
    height?: string;
    maxHeight?: string;
    minHeight?: string;
    className?: string;
}

const InfiniteScroll = ({ onIntersect, hasMore, children, height, maxHeight, minHeight, className }: InfiniteScrollProps) => {
    const sentinelRef = useRef<HTMLDivElement | null>(null);

    useEffect(() => {
        const options = {
            root: null,
            rootMargin: "0px",
            threshold: 0.5
        };

        const observer = new IntersectionObserver(entries => {
            const [entry] = entries;
            if (entry.isIntersecting && hasMore) {
                onIntersect();
            }
        }, options);

        const sentinelRefCurrent = sentinelRef.current;

        if (sentinelRefCurrent) {
            observer.observe(sentinelRefCurrent);
        }

        return () => {
            if (sentinelRefCurrent) {
                observer.unobserve(sentinelRefCurrent);
            }
        };
    }, [onIntersect, hasMore]);

    const style: CSSProperties = {
        overflowY: "auto",
        height,
        minHeight,
        maxHeight
    };

    const infClassName = classNames("infinite-scroll-wrapper", {
        [`${className}`]: className
    });

    return (
        <div className={infClassName} style={style}>
            {children}
            <div ref={sentinelRef} />
        </div>
    );
};

export default InfiniteScroll;
